import React, {useEffect} from "react";
import {TabsProps} from "antd";
import "./MonitorBHXH.scss";
import {useAppDispatch, useAppSelector} from "redux/hooks";

import {tabKeys} from "types/enums/tab-keys";
import {Tabs} from "components/common";
import ListMonitorBHXH from "./Tab/ListMonitorBHXH";
import ListSalarySettings from "../SalarySettings/Tab/ListSalarySettings";
import {setSiderKey} from "redux/reducer/common";

const MonitorBHXH: React.FC = () => {
  document.title = "Theo dõi BHXH";
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setSiderKey("bhxh"));
  }, []);

  return (
    <div className="monitor-bhxh  page">
      <div className="main">
        <ListMonitorBHXH />
      </div>
    </div>
  );
};
export default MonitorBHXH;
